import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addIntervieweeSchema = Yup.object()
  .shape({
    candidateName: Yup.string().required(
      Strings.validation.selectRequired(Strings.addCandidate.candidateName)
    ),
    interviewer: Yup.string().required(
      Strings.validation.selectRequired(Strings.addCandidate.interviewer)
    ),
    interviewTime: Yup.string().required(
      Strings.validation.selectRequired(Strings.addCandidate.interviewTime)
    ),
  })
  .required();
export const updateIntervieweeStatusSchema = Yup.object()
  .shape({
    reason: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.reason))
      .test('is-not-empty', 'Reason cannot be empty', (value) => value.trim().length > 0),
  })
  .required();
